import React, { Component } from 'react';

class Portfolio extends Component {
  render() {
    if (!this.props.data) return null;

    const expertise = [
      {
        icon: 'fa-cloud',
        title: 'Cloud-Native Architecture',
        description: 'Design and implement scalable, resilient systems using AWS, Kubernetes, and Docker. Build infrastructure that scales from zero to millions of users.',
        metrics: ['99.9% Uptime', '10x Scale', 'Auto-Healing'],
        tags: ['AWS', 'Kubernetes', 'Docker', 'Terraform']
      },
      {
        icon: 'fa-database',
        title: 'Distributed Systems',
        description: 'Build high-performance distributed systems with event-driven architecture, microservices, and real-time data processing at scale.',
        metrics: ['Low Latency', 'High Throughput', 'Fault Tolerant'],
        tags: ['Kafka', 'Elasticsearch', 'PostgreSQL', 'Redis']
      },
      {
        icon: 'fa-robot',
        title: 'AI/ML Integration',
        description: 'Integrate cutting-edge AI capabilities including LLMs, autonomous agents, and machine learning models into production systems.',
        metrics: ['Real-time AI', 'Model Serving', 'MLOps'],
        tags: ['TensorFlow', 'PyTorch', 'LLMs', 'OpenAI']
      },
      {
        icon: 'fa-code',
        title: 'API & SDK Development',
        description: 'Create developer-friendly APIs and SDKs with comprehensive documentation, reducing integration time and support overhead.',
        metrics: ['30% Less Support', '40% Faster Onboarding', 'Multi-Platform'],
        tags: ['REST', 'GraphQL', 'gRPC', 'Documentation']
      },
      {
        icon: 'fa-rocket',
        title: 'DevOps & Automation',
        description: 'Build CI/CD pipelines, automate infrastructure provisioning, and implement monitoring solutions that reduce deployment time by 45%.',
        metrics: ['60% Less Downtime', '45% Faster Deploy', 'Zero-Touch'],
        tags: ['GitHub Actions', 'Jenkins', 'Prometheus', 'Grafana']
      },
      {
        icon: 'fa-line-chart',
        title: 'Data Infrastructure',
        description: 'Design and maintain data pipelines, ETL processes, and analytics infrastructure that process millions of events daily.',
        metrics: ['Real-time Processing', 'Petabyte Scale', 'Cost Optimized'],
        tags: ['Data Pipelines', 'ETL', 'Analytics', 'Optimization']
      }
    ];

    return (
      <section id="portfolio">
        <div className="container">
          <div className="expertise-header">
            <h1>What I Build</h1>
            <p className="expertise-subtitle">
              Turning complex technical challenges into elegant, scalable solutions that drive real business impact
            </p>
          </div>

          {/* Impact Stats */}
          <div className="impact-stats">
            <div className="stat-card">
              <div className="stat-number">8+</div>
              <div className="stat-label">Years Experience</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">50+</div>
              <div className="stat-label">Projects Delivered</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">99.9%</div>
              <div className="stat-label">System Uptime</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">45%</div>
              <div className="stat-label">Faster Deployments</div>
            </div>
          </div>

          {/* Expertise Cards */}
          <div className="expertise-grid">
            {expertise.map((item, index) => (
              <div key={index} className="expertise-card">
                <div className="expertise-icon">
                  <i className={`fa ${item.icon}`}></i>
                </div>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
                
                <div className="expertise-metrics">
                  {item.metrics.map((metric, idx) => (
                    <span key={idx} className="metric-badge">
                      <i className="fa fa-check-circle"></i> {metric}
                    </span>
                  ))}
                </div>

                <div className="expertise-tags">
                  {item.tags.map((tag, idx) => (
                    <span key={idx} className="tech-tag">{tag}</span>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    );
  }
}

export default Portfolio;
